import { ClusteredMarkerLayer } from '../Layers/ClusteredMarkersLayer';
import { FilterLayer } from '../Layers/FilterLayer';
import type { FilterLayerOptions } from '../Layers/Layers.types';

export const allShuttleParkingsGbgFilter = function (layers: ClusteredMarkerLayer[], options?: FilterLayerOptions): FilterLayer {
    const defaultOptions: FilterLayerOptions = {
        filterFn: (filteredFeatures, allFeatures) => allFeatures,
        order: 1000,
    };

    return new FilterLayer('all-shuttle-parking-gbg', layers, { ...defaultOptions, ...options });
};
